import React from "react";
import PropTypes from "prop-types";

const List = props => {
	const { items, renderItem, defaultText } = props;

	const shouldDisplayItems = items && items.length > 0 && renderItem;

	const defaultMessage = defaultText ? defaultText : "No items to display";

	return (
		<div className="list">
			{shouldDisplayItems ? (
				items.map(item => renderItem({ item }))
			) : (
				<h2 className="default-text">{defaultMessage}</h2>
			)}
		</div>
	);
};

List.propTypes = {
	items: PropTypes.array,
	renderItem: PropTypes.func,
	defaultText: PropTypes.string,
};

export default List;
